export const updateDisseminationLessonService =
  (fetch) => async (disseminationLesson) => {
    try {
      const formData = new FormData();
      formData.append("accident", disseminationLesson.accident);
      if (disseminationLesson.lesson instanceof File) {
        formData.append("file", disseminationLesson.lesson);
      }

      const response = await fetch({
        url: `/api/v1/siniestros-viales/divulgacion-lecciones/${disseminationLesson.id}`,
        method: "put",
        body: formData,
        contentType: "multipart/form-data",
      });
      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
